<template>
  <div class="page-container">
    <nav-bar></nav-bar>
    <div class="page">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="title-coontainer">
              <h5 class="card-title">Patients ({{ count }})</h5>
              <pager
                class="pager"
                :limit="limit"
                @onPageChanged="onPageChanged"
              ></pager>
              <div
                title="Filters"
                class="bt-filters"
                :class="{ 'bt-filter-selected': openFilters }"
                @click="openFilters = !openFilters"
              >
                <img src="../assets/ic_filter.png" alt="" />
              </div>
            </div>

            <div class="filters-container" v-if="openFilters">
              <span>Filters</span>
              <span></span>
              <span></span>
              <filter-field
                name="Name"
                type="text"
                v-model="filters.name"
                placeholder="Enter title to search"
              />

              <filter-field
                name="Email"
                type="text"
                v-model="filters.email"
                placeholder="Enter an email address"
              />

              <filter-field
                name="Phone"
                type="text"
                v-model="filters.phone"
                placeholder="Enter a phone number"
              />

              <filter-field
                name="Gender"
                type="select"
                v-model="filters.gender"
                placeholder="Select a gender to filter"
                :options="['male', 'female', 'other']"
              />

              <filter-field
                name="City"
                type="text"
                v-model="filters.city"
                placeholder="Enter a city name"
              />

              <div class="actions">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  @click="search"
                >
                  Search
                </button>

                <button
                  type="button"
                  class="btn btn-outline-danger"
                  @click="clearFilters"
                  v-if="haveFilters()"
                >
                  Clear Filters
                </button>
              </div>
            </div>

            <div class="empty" v-if="patients.length <= 0">
              <img src="../assets/empty.svg" />
              <span>No data to show ...</span>
            </div>

            <table class="table table-striped" v-else>
              <thead>
                <tr>
                  <td scope="col">Name</td>
                  <td scope="col">Gender</td>
                  <td scope="col">Email</td>
                  <td scope="col">Phone</td>
                  <td scope="col">City</td>
                  <td scope="col">Address</td>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="patient.id" v-for="patient in patients">
                  <td>{{ patient.name || "--" }}</td>
                  <td style="text-transform: capitalize">
                    {{ patient.gender || "--" }}
                  </td>
                  <td>{{ patient.email || "--" }}</td>
                  <td>{{ patient.phone || "--" }}</td>
                  <td>{{ patient.city || "--" }}</td>
                  <td>{{ patient.address || "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { HTTP, URLS } from "../network/http";
import Pager from "../components/Pager";
var NotificationsController = require("../components/NotificationsController.js");
import FilterField from "../components/FilterField.vue";

import moment from "moment";
export default {
  name: "Patients",
  components: {
    NavBar,
    Pager,
    FilterField,
  },
  data() {
    return {
      keyword: "",
      resultsPerPage: 10,
      count: 0,
      page: 1,
      limit: 0,
      patients: [],
      openFilters: false,
      filters: {},
    };
  },
  methods: {
    clearFilters() {
      this.filters = {};
      this.page = 1;
      this.getAdmins();
    },
    haveFilters() {
      return !Object.values(this.filters).every((x) => x === null || x === "");
    },
    search() {
      if (!this.haveFilters()) {
        this.$toast.warning("Please select a filter first");
        return;
      }
      this.page = 1;
      this.getAdmins();
    },
    onPageChanged(page) {
      this.page = page;
      this.getAdmins();
    },
    getAdmins() {
      NotificationsController.showActivityIndicator();
      const ctx = this;
      var url = URLS.PATIENTS.LIST;
      url = url + "?limit=" + this.resultsPerPage;
      url = url + "&page=" + this.page;
      if (this.keyword) {
        url = url + "&name=" + this.keyword;
      }

      let where = {};
      if (this.haveFilters()) {
        Object.keys(this.filters).forEach((e) => {
          console.log(e);
          let val = this.filters[e];
          if (val !== null && val !== "") {
            where[e] = val;
          }
        });
      }

      HTTP.get(url, {
        params: { where: where },
      })
        .then((response) => {
          let data = response.data;
          let rows = data.rows;
          ctx.count = data.count;
          let limit = Math.ceil(data.count / ctx.resultsPerPage);
          ctx.limit = limit;
          ctx.previousEnable = limit > 0;
          ctx.nextEnable = ctx.page < limit;
          ctx.patients = rows;
          NotificationsController.hideActivityIndicator();
        })
        .catch((err) => {
          NotificationsController.hideActivityIndicator();
        });
    },
  },
  mounted() {
    this.getAdmins();
    this.moment = moment;
  },
};
</script>

<style lang="scss">
.page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  nav-bar {
    height: 100px;
    width: 100%;
  }

  .page {
    width: 100%;
    height: 90%;
    overflow-y: scroll;
  }

  .title-coontainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;

    .pager {
      margin-left: auto;
      margin-right: 1rem;
    }

    .bt-filters {
      height: 3rem;
      width: 3rem;
      display: flex;
      border: 0.1rem solid rgb(250, 165, 6);
      border-radius: 4px;
      transition: all 0.2s ease-in-out;

      img {
        width: 40%;
        margin: auto;
        filter: invert(78%) sepia(51%) saturate(4655%) hue-rotate(357deg)
          brightness(104%) contrast(99%);
        transition: all 0.2s ease-in-out;
      }

      &:hover {
        background: orange;
        img {
          filter: invert(100%) sepia(0%) saturate(7480%) hue-rotate(143deg)
            brightness(104%) contrast(104%);
        }
      }
    }

    .bt-filter-selected {
      background: orange;
      border-radius: 50%;
      img {
        filter: invert(100%) sepia(0%) saturate(7480%) hue-rotate(143deg)
          brightness(104%) contrast(104%);
      }
    }
  }
}

.table-card {
  box-shadow: 0px 0px 10px 0px #bdbdbd;
}

.filters-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem;
  // button{
  //   margin-left: 10px;
  // }
  span {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .actions {
    display: -ms-inline-grid;
    width: 100%;

    gap: 0.5rem;
    button {
      width: 100%;
      height: 100%;
    }
  }
}

.actions {
  button {
    margin-right: 4px;
  }
}
</style>
